import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from 'src/interfaces';

interface UserState {
  current: IUser | {
    _id: null;
    avatar: string;
    cover: null;
    name: string;
    email: string;
    balance?: number;
  };
  error: any;
  updateSuccess: boolean;
  updating: boolean;
  updatedPassword?: any;
}

const initialState: UserState = {
  current: {
    _id: null,
    avatar: '/no-avatar.jpg',
    cover: null,
    name: '',
    email: ''
  },
  error: null,
  updateSuccess: false,
  updating: false
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateCurrentUser(state, action: PayloadAction<any>) {
      state.current = action.payload;
    },
    updateCurrentUserAvatar(state, action: PayloadAction<string>) {
      if (state.current) {
        state.current.avatar = action.payload;
      }
    },
    updateCurrentUserCover(state, action: PayloadAction<string>) {
      if (state.current) {
        state.current.cover = action.payload;
      }
    },
    updateUserSuccess(state, action: PayloadAction<IUser>) {
      state.current = action.payload;
      state.updateSuccess = true;
      state.error = null;
    },
    updateUserFail(state, action: PayloadAction<any>) {
      state.updateSuccess = false;
      state.error = action.payload;
    },
    setUpdating(state, action: PayloadAction<boolean>) {
      state.updating = action.payload;
    },
    updatePasswordSuccess(state, action: PayloadAction<any>) {
      state.updateSuccess = true;
      state.updatedPassword = action.payload;
      state.error = null;
    },
    updatePasswordFail(state, action: PayloadAction<any>) {
      state.updateSuccess = false;
      state.updatedPassword = null;
      state.error = action.payload;
    },
    updateBalance(state, action: PayloadAction<{ token: number }>) {
      if (state.current && 'balance' in state.current) {
        state.current.balance = (state.current.balance || 0) + action.payload.token;
      }
    },
    updatePerformer(state, action: PayloadAction<any>) {
      // This action triggers the saga to update performer data
      state.updating = true;
      state.error = null;
    },
    updateUser(state, action: PayloadAction<any>) {
      // This action triggers the saga to update user data
      state.updating = true;
      state.error = null;
    },
    resetUser() {
      return initialState;
    }
  }
});

export const {
  updateCurrentUser,
  updateCurrentUserAvatar,
  updateCurrentUserCover,
  updateUserSuccess,
  updateUserFail,
  setUpdating,
  updatePasswordSuccess,
  updatePasswordFail,
  updateBalance,
  updatePerformer,
  updateUser,
  resetUser
} = userSlice.actions;

export default userSlice.reducer;